import { FEATURES, MODAL, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/gestao-desempenho',
    name: 'rh',
    redirect: '/gestao-desempenho/',
    meta: {
      can_show: FEATURES.RH,
      search: {
        title: 'Gestão de Desempenho',
        description: 'Avaliações e performance da equipe',
        keywords: ['rh', 'desempenho', 'avaliação', 'performance', 'equipe'],
        icon: 'users',
        group: SEARCH_GROUPS.GESTAO_PESSOAS,
      },
    },
    component: () =>
      lazyLoadView(import('@modules/rh/views/nav-bar/rh-nav-bar.vue')),
    children: [
      {
        path: '',
        name: 'rh.geral',
        meta: {
          can_show: FEATURES.RH,
        },
        component: () =>
          lazyLoadView(import('@modules/rh/views/view-general/general.vue')),
      },
      {
        path: 'analise-quantitativa',
        name: 'rh.quantitativa',
        meta: {
          can_show: [FEATURES.RH],
          search: {
            title: 'Análise Quantitativa',
            description: 'Indicadores quantitativos de desempenho da equipe',
            keywords: [
              'quantitativa',
              'indicadores',
              'métricas',
              'performance',
            ],
            group: SEARCH_GROUPS.GESTAO_PESSOAS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/rh/views/view-valuation-quantitative/valuation-quantitative.vue'
            )
          ),
      },
      {
        path: 'analise-comercial',
        name: 'rh.comercial',
        meta: {
          can_show: FEATURES.RH,
          search: {
            title: 'Análise Comercial',
            description: 'Desempenho comercial e de vendas da equipe',
            keywords: ['comercial', 'vendas', 'captação', 'performance'],
            group: SEARCH_GROUPS.GESTAO_PESSOAS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/rh/views/view-valuation-commercial/valuation-commercial.vue'
            )
          ),
      },
      {
        path: 'analise-qualitativa',
        name: 'rh.qualitativa',
        meta: {
          can_show: FEATURES.RH,
          search: {
            title: 'Análise Qualitativa',
            description: 'Avaliação qualitativa e de competências',
            keywords: ['qualitativa', 'competências', 'feedback', 'avaliação'],
            group: SEARCH_GROUPS.GESTAO_PESSOAS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/rh/views/view-evaluation-qualitative/evaluation-qualitative.vue'
            )
          ),
      },
      {
        path: 'avaliacoes',
        name: 'rh.avaliacao',
        meta: {
          can_show: FEATURES.RH,
          search: {
            title: 'Avaliações',
            description: 'Avaliações de desempenho dos profissionais',
            keywords: ['avaliações', 'desempenho', 'feedback', 'notas'],
            group: SEARCH_GROUPS.GESTAO_PESSOAS,
            actions: [
              {
                id: 'criar-avaliacao',
                title: 'Criar avaliação de desempenho',
                keywords: [
                  'avaliação',
                  'desempenho',
                  'nova avaliação',
                  'feedback',
                ],
                to: { name: 'rh.avaliacao' },
                modal: MODAL.ADD_NEW_VALUATION,
              },
            ],
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/rh/views/view-valuation-page/view-valuation-page.vue'
            )
          ),
      },
    ],
  },
]
